import axios, { AxiosError } from 'axios';

import { REACT_APP_CUBEJS_BETA_BASE_URL } from '../constants/envConstants';

export const loadCubeQuery = async query => {
  try {
    const response = await axios.post(
      `${REACT_APP_CUBEJS_BETA_BASE_URL}/load`,
      query,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return {
      error: false,
      message: 'Data Fetched Successfully.',
      data: response?.data?.data,
    };
  } catch (error) {
    console.error(error);
    return {
      error: true,
      message:
        error instanceof AxiosError ? error?.response?.data?.error : 'Error',
      data: [],
    };
  }
};
